import { adminFetch } from "./_client";
import type { VinInfo, VinMatch, InngestFunction, PushSendResult } from "./types";


export function checkVin(token: string, vin: string) {
  return adminFetch<{ vinInfo: VinInfo; matches: VinMatch[] }>("/admin/tools/vin-check", token, {
    method: "POST",
    body: JSON.stringify({ vin }),
  });
}


export function fetchInngestFunctions(token: string) {
  return adminFetch<{ functions: InngestFunction[] }>("/admin/tools/inngest-functions", token);
}


export function triggerInngestFunction(token: string, functionId: string) {
  return adminFetch<{ success: boolean; message: string }>("/admin/tools/inngest-trigger", token, {
    method: "POST",
    body: JSON.stringify({ functionId }),
  });
}


export function sendPushNotification(token: string, data: { userId?: string; segment?: string; title: string; message: string; actionUrl?: string }) {
  return adminFetch<PushSendResult>("/admin/tools/push-send", token, {
    method: "POST",
    body: JSON.stringify(data),
  });
}
